import type { WorkItem } from '@/modules/project/api/work-item'
import { getWorkItem } from '@/modules/project/api/work-item'

/** 视频工作区视图：由 WorkItem 映射，供校对/结果页使用。 */
export interface VideoWorkspaceView {
  id: number
  project_id: number
  title: string
  status: string
  pipeline_stage?: string
  original_language?: string
  target_languages: string[]
  video_duration?: number | null
  updated_at?: string | null
  video_file_storage_id?: number | null
  file_storage_id?: number | null
  original_subtitle_url?: string | null
  subtitle_url?: string | null
  file_url?: string | null
  has_video: boolean
}

export function mapWorkItemToVideoWorkspace(item: WorkItem): VideoWorkspaceView {
  const videoFileStorageId = item.video_file_storage_id ?? null
  const fileStorageId = item.file_storage_id ?? null
  const hasVideo = Boolean(videoFileStorageId || fileStorageId || item.file_url)
  return {
    id: item.id,
    project_id: item.project_id,
    title: item.file_name ?? `#${item.id}`,
    status: item.status,
    pipeline_stage: item.pipeline_stage,
    original_language: item.source_language ?? undefined,
    target_languages: item.target_language ? [item.target_language] : [],
    video_duration: item.video_duration,
    updated_at: item.completed_at ?? item.created_at ?? null,
    video_file_storage_id: videoFileStorageId,
    file_storage_id: fileStorageId,
    original_subtitle_url: item.subtitle_url ?? null,
    subtitle_url: item.subtitle_url ?? null,
    file_url: item.file_url ?? null,
    has_video: hasVideo,
  }
}

export async function getVideoWorkspace(
  workItemId: number,
): Promise<VideoWorkspaceView> {
  const item = await getWorkItem(workItemId)
  return mapWorkItemToVideoWorkspace(item)
}
